export default "/img/BN.2f475a886e2e85b5eed22e3c61fa6450.png";